import { render, staticRenderFns } from "./PersonIndex.vue?vue&type=template&id=1022779d&scoped=true&"
import script from "./PersonIndex.vue?vue&type=script&lang=js&"
export * from "./PersonIndex.vue?vue&type=script&lang=js&"
import style0 from "./PersonIndex.vue?vue&type=style&index=0&id=1022779d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1022779d",
  null
  
)

export default component.exports